module.exports = __webpack_public_path__ + "img/ic-info-blue.c78b500a.svg";